import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraBusinessService } from '../../models/doraBusinessService.ts';

interface DoraBusinessServiceState {
  doraBusinessServices: DoraBusinessService[];
  selectedDoraBusinessService: DoraBusinessService | null;
}

const initialState: DoraBusinessServiceState = {
  doraBusinessServices: [],
  selectedDoraBusinessService: null,
};

const doraBusinessServiceSlice = createSlice({
  name: 'doraBusinessService',
  initialState,
  reducers: {
    setDoraBusinessServices(state, action: PayloadAction<DoraBusinessService[]>) {
      state.doraBusinessServices = action.payload;
    },
    addDoraBusinessService(state, action: PayloadAction<DoraBusinessService>) {
      state.doraBusinessServices.push(action.payload);
    },
    updateDoraBusinessService(state, action: PayloadAction<DoraBusinessService>) {
      const index = state.doraBusinessServices.findIndex(service => service.id === action.payload.id);
      if (index !== -1) state.doraBusinessServices[index] = action.payload;
    },
    removeDoraBusinessService(state, action: PayloadAction<number>) {
      state.doraBusinessServices = state.doraBusinessServices.filter(service => service.id !== action.payload);
    },
    setSelectedDoraBusinessService(state, action: PayloadAction<DoraBusinessService | null>) {
      state.selectedDoraBusinessService = action.payload;
    },
  },
});

export const {
  setDoraBusinessServices,
  addDoraBusinessService,
  updateDoraBusinessService,
  removeDoraBusinessService,
  setSelectedDoraBusinessService,
} = doraBusinessServiceSlice.actions;

export const selectDoraBusinessServices = (state: RootState) => state.doraBusinessService.doraBusinessServices;
export const selectSelectedDoraBusinessService = (state: RootState) => state.doraBusinessService.selectedDoraBusinessService;

export default doraBusinessServiceSlice.reducer;
